module.exports = __webpack_public_path__ + "766b00fdfbe08280e782e690eed6eeb8.fbx";